import { FC } from "react";
import MaterialLink from "@mui/material/Link";

import "./Link.scss";

type LinkProps = {
  variant?: any;
  href?: string;
  children: any;
  className?: string;
  onClick?: (event: any) => void;
};

const Link: FC<LinkProps> = ({
  variant,
  href,
  className = "",
  children,
  onClick
}: LinkProps) => {
  return (
    <MaterialLink
      variant={variant}
      href={href}
      className={`text-link override ${className}`}
      onClick={onClick}
    >
      {children}
    </MaterialLink>
  );
};

export default Link;
